import React from 'react';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { ErrorOutline } from '@material-ui/icons';

import api from '../../api/api';

export class ErrorBoundary extends React.Component<
  React.ComponentProps<any>,
  { hasError: boolean; errorId: string | undefined; error: Error | undefined }
> {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: undefined, errorId: undefined };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
      errorId: Date.now() + '' + Math.trunc(Math.random() * 100),
    };
  }

  componentDidCatch(error, errorInfo) {
    api.service.log({
      id: this.state.errorId,
      error: error.name,
      message: error.message,
      location: document.location.pathname,
      errorStack: error.stack,
      stack: errorInfo.componentStack,
    });
  }

  share() {
    if (navigator.share) {
      navigator
        .share({
          title: `Error (${this.state.errorId}): ${this.state.error.name} `,
        });
      return;
    }

    navigator.clipboard.writeText(
      `Error (${this.state.errorId}): ${this.state.error.name} `
    );
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box paddingX={{ xs: 0, sm: 2, md: 10, lg: 14, xl: 20 }}>
          <Paper>
            <Box paddingX={2} paddingY={3}>
              <Box marginBottom={2} display="flex">
                <ErrorOutline color="error" />
                <Box marginLeft={1} display="flex">
                  <Typography variant="h6" color="error">
                    Что-то пошло не так
                  </Typography>
                </Box>
              </Box>
              <Box marginBottom={2}>
                <Button onClick={() => document.location.reload()}>
                  Перезагрузить
                </Button>
              </Box>
              <Box marginBottom={2}>
                <Alert severity="warning">
                  <strong>
                    Возможно мы уже знаем о проблеме и постараемся решить ее в
                    короткий срок.
                  </strong>{' '}
                  Вы так же поможете нам, если дополнительно опубликуете
                  сообщение с ошибкой в чате <strong>&quot;SNEG&quot;</strong> в WhatsApp
                  с помощью этой{' '}
                  <a href="#" onClick={this.share}>
                    ссылки
                  </a>{' '}
                  или <strong>скриншот этого сообщения</strong>.
                </Alert>
              </Box>
              <Box marginBottom={2}>
                <Alert severity="error">
                  <strong>{this.state?.errorId}</strong> -{' '}
                  {this.state?.error.name}
                </Alert>
              </Box>
              <Box marginBottom={2}>
                <Alert severity="error" icon={false}>
                  {this.state?.error.stack}
                </Alert>
              </Box>
            </Box>
          </Paper>
        </Box>
      );
    }

    return this.props.children;
  }
}
